/**
 * Les phrases de l'overlay d'essai. Cet overlay ne sert qu'a l'essai d'OBS (geste `castellan-obs-essai`) :
 * ses phrases sont donc visibles, contrairement a celles des overlays qui passent a l'ecran du stream et
 * ne doivent jamais montrer leur panne aux viewers. Aucune ne cite la cle ni ce que le serveur a repondu.
 */

/** Le son joue a chaque changement de scene : un bip court, servi par le frontal (`public/sons`). */
export const SON_ESSAI = "/sons/essai.mp3";

/** Le nom que l'overlay donne a la regie comme source du signalement. */
export const SOURCE_ESSAI = "essai";

export const OVERLAY_CLE_ABSENTE =
  "Clé absente : ouvre l'adresse donnée par la régie, avec #cle=... à la fin.";
export const OVERLAY_HORS_OBS =
  "Hors d'OBS : cette page ne signale rien dans un navigateur ordinaire.";
export const OVERLAY_ATTENTE = "En attente de la scène d'OBS...";
// Une clé fausse, périmée ou jamais posée reçoivent le même refus (401) : l'overlay ne distingue pas.
export const OVERLAY_CLE_REFUSEE =
  "Clé refusée : régénère-la dans la régie, puis recolle l'adresse dans la source d'OBS.";
export const OVERLAY_ENVOI_ECHEC =
  "L'envoi a échoué : la régie ne répond pas. Il sera refait au prochain changement de scène.";

export function overlayEnvoyee(nom: string): string {
  return `Scène envoyée : ${nom}.`;
}

const ETATS_FLUX = {
  connexion: "connexion...",
  connecte: "connecté",
  coupe: "coupé, reprise en cours",
} as const;

/** L'etat du flux temps reel et le genre du dernier message recu, pour l'essai seulement. */
export function overlayFlux(etat: keyof typeof ETATS_FLUX, dernier: string | null): string {
  const message = dernier === null ? "aucun message reçu" : `dernier message : ${dernier}`;
  return `Flux : ${ETATS_FLUX[etat]}, ${message}.`;
}
